export const PROVIDERS_PAGE_SIZE_OPTIONS = [20, 50, 100];
